// extracted by mini-css-extract-plugin
module.exports = {"week":"week_week__TZvOz","firstWeek":"week_firstWeek__2fclE"};